// extracted by mini-css-extract-plugin
module.exports = {"ecRecommendationsTabToast":"RecommendationsTab_ecRecommendationsTabToast__bKguG","showScale":"RecommendationsTab_showScale__U4P5b"};